export const inputCls =
  "w-full min-h-[3.25rem] rounded-md border border-input bg-card px-4 py-3 text-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring";

export const textareaCls = `${inputCls} min-h-[8rem]`;

export const Field = ({ label, id, required, children }) => (
  <div>
    <label htmlFor={id} className="block text-lg font-semibold text-foreground mb-2">
      {label}
      {required && <span className="text-destructive" aria-hidden="true"> *</span>}
    </label>
    {children}
  </div>
);

export const CheckboxGroup = ({ legend, options, values, onChange, testId }) => (
  <fieldset>
    <legend className="text-lg font-semibold text-foreground mb-3">{legend}</legend>
    <div className="grid gap-3 sm:grid-cols-2">
      {options.map((opt) => (
        <label
          key={opt}
          className="flex items-center gap-3 bg-card border border-border rounded-md px-4 py-3 cursor-pointer transition-colors duration-200 hover:border-secondary"
        >
          <input
            type="checkbox"
            data-testid={`${testId}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="h-6 w-6 shrink-0 accent-[#0A192F]"
            checked={values.includes(opt)}
            onChange={(e) =>
              onChange(e.target.checked ? [...values, opt] : values.filter((v) => v !== opt))
            }
          />
          <span className="text-lg">{opt}</span>
        </label>
      ))}
    </div>
  </fieldset>
);

export const Honeypot = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
    <label htmlFor="website">Website</label>
    <input
      id="website"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
